import gql from 'graphql-tag';

const CREATE_SERVICE_ORDER_STATUS = gql`
  mutation CreateServiceOrderStatus($data: CreateServiceOrderStatusInput!) {
    createServiceOrderStatus(data: $data) {
      id
      workspaceId
      description
      serviceOrderIds
      isDefault
      createdAt
      updatedAt
    }
  }
`;

const UPDATE_SERVICE_ORDER_STATUS = gql`
  mutation UpdateServiceOrderStatus(
    $serviceOrderStatusId: ID!
    $data: UpdateServiceOrderStatusInput!
  ) {
    updateServiceOrderStatus(id: $serviceOrderStatusId, data: $data) {
      id
      workspaceId
      description
      serviceOrderIds
      isDefault
      createdAt
      updatedAt
    }
  }
`;

const DELETE_SERVICE_ORDER_STATUS = gql`
  mutation DeleteServiceOrderStatus($serviceOrderStatusId: ID!) {
    deleteServiceOrderStatus(id: $serviceOrderStatusId) {
      id
    }
  }
`;

const CREATE_SERVICE_ORDER = gql`
  mutation CreateServiceOrder($data: CreateServiceOrderInput!) {
    createServiceOrder(data: $data) {
      id
      leadTechnician {
        id
        firstName
        lastName
        profilePicture
      }
      technicians {
        id
        firstName
        lastName
        profilePicture
      }
      deviceId
      title
      description
      isFinished
      executedAt
      createdAt
      updatedAt
      statusId
      status {
        id
        description
      }
      serviceOrderLogs {
        id
        serviceOrderId
        userId
        type
        comment
        createdAt
        updatedAt
        metaData
        attachments {
          fileName
          originalFilename
          fileType
          url
        }
      }
      serviceOrderTasks {
        id
        serviceOrderId
        description
        isCompleted
        createdAt
        updatedAt
      }
      scheduledAt
      priority
    }
  }
`;

const UPDATE_SERVICE_ORDER_BY_ID = gql`
  mutation UpdateServiceOrder(
    $serviceOrderId: ID!
    $data: UpdateServiceOrderInput!
  ) {
    updateServiceOrder(id: $serviceOrderId, data: $data) {
      id
      leadTechnician {
        id
        firstName
        lastName
        profilePicture
      }
      technicians {
        id
        firstName
        lastName
        profilePicture
      }
      deviceId
      title
      description
      isFinished
      executedAt
      createdAt
      updatedAt
      statusId
      status {
        id
        description
      }
      serviceOrderLogs {
        id
        serviceOrderId
        userId
        type
        comment
        createdAt
        updatedAt
        metaData
        attachments {
          fileName
          originalFilename
          fileType
          url
        }
      }
      serviceOrderTasks {
        id
        serviceOrderId
        description
        isCompleted
        createdAt
        updatedAt
      }
      scheduledAt
      priority
    }
  }
`;

const DELETE_SERVICE_ORDER_BY_ID = gql`
  mutation DeleteServiceOrder($serviceOrderId: ID!) {
    deleteServiceOrder(id: $serviceOrderId) {
      id
    }
  }
`;

const ADD_SERVICE_ORDER_LOG = gql`
  mutation AddServiceOrderLog($data: ServiceOrderLogInput!) {
    addServiceOrderLog(data: $data) {
      id
      serviceOrderId
      userId
      type
      createdAt
      updatedAt
      comment
      metaData
      attachments {
        fileName
        originalFilename
        fileType
        url
      }
    }
  }
`;

const ADD_SERVICE_ORDER_SUBTASK = gql`
  mutation CreateServiceOrderTask($serviceOrderId: ID!, $description: String!) {
    createServiceOrderTask(
      serviceOrderId: $serviceOrderId
      description: $description
    ) {
      id
      serviceOrderId
      description
      isCompleted
      createdAt
      updatedAt
    }
  }
`;

const UPDATE_SERVICE_ORDER_SUBTASK = gql`
  mutation UpdateServiceOrderTask(
    $serviceOrderTaskId: ID!
    $data: UpdateServiceOrderTaskInput!
  ) {
    updateServiceOrderTask(id: $serviceOrderTaskId, data: $data) {
      id
      serviceOrderId
      description
      isCompleted
      createdAt
      updatedAt
    }
  }
`;

const DELETE_SERVICE_ORDER_SUBTASK = gql`
  mutation DeleteServiceOrderTask($id: ID!) {
    deleteServiceOrderTask(id: $id) {
      id
      serviceOrderId
    }
  }
`;

export default {
  CREATE_SERVICE_ORDER_STATUS,
  UPDATE_SERVICE_ORDER_STATUS,
  DELETE_SERVICE_ORDER_STATUS,
  CREATE_SERVICE_ORDER,
  UPDATE_SERVICE_ORDER_BY_ID,
  DELETE_SERVICE_ORDER_BY_ID,
  ADD_SERVICE_ORDER_LOG,
  ADD_SERVICE_ORDER_SUBTASK,
  UPDATE_SERVICE_ORDER_SUBTASK,
  DELETE_SERVICE_ORDER_SUBTASK,
};
